// Adapted from https://gist.github.com/cbosco/4339f6d842c6c9ac35f21982e98b4412
/**
 * This component can truncate text AND HTML markup with ellipsis.
 * Inspired by this github issue: https://github.com/One-com/react-truncate/issues/8#issuecomment-262639343
 * This component is not managed by react VDOM and mutates its own DOM
 */
import React, { Component } from "react";

class Truncate extends Component {
  configure() {
    const { lines } = this.props;
    this.title = null;
    this.ellipsis = window.Ellipsis({
      ellipsis: "…", //default ellipsis value
      debounce: 500, //if you want to chill out your memory usage on resizing
      responsive: true, //if you want the ellipsis to move with the window resizing
      class: false,
      lines: lines || 2, //default number of lines when the ellipsis will appear
      break_word: true //default the ellipsis can truncate words
    });
  }
  UNSAFE_componentWillMount() {
    this.configure();
  }
  componentDidMount() {
    if (this.ellipsis && this.truncateContainer) {
      this.ellipsis.add(this.truncateContainer);
    }
  }
  componentWillUnmount() {
    this.ellipsis.destroy();
  }

  shouldComponentUpdate() {
    if (this.truncateContainer.offsetWidth !== this.lastWidth) {
      this.ellipsis.listener();
    }
    this.lastWidth = this.truncateContainer.offsetWidth;
    return false;
  }

  render() {
    const { children } = this.props;

    return (
      <span
        title={children}
        ref={node => {
          this.truncateContainer = node;
        }}
      >
        {this.props.children}
      </span>
    );
  }
}

module.exports = Truncate;
